import scraperImage from "../assets/scraperImage.webp";
import voiceTranscriptImage from "../assets/voiceTranscriptImage.webp";
import emailAgentImage from "../assets/emailAgentImage.webp";
import writeBetterImage from "../assets/writeBetterImage.webp";

// Card copy lives in the i18n resources (projects.accelerators); the images are
// matched to the translated entries by position.
export const acceleratorCardImages = [
  scraperImage,
  voiceTranscriptImage,
  emailAgentImage,
  writeBetterImage,
];
